import { render, staticRenderFns } from "./LeaveRequest.vue?vue&type=template&id=4744ccf0&scoped=true"
import script from "./LeaveRequest.vue?vue&type=script&lang=js"
export * from "./LeaveRequest.vue?vue&type=script&lang=js"
import style0 from "./LeaveRequest.vue?vue&type=style&index=0&id=4744ccf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4744ccf0",
  null
  
)

export default component.exports